module.exports = __webpack_public_path__ + "static/img/AX@2x.173ea687.jpg";